module.exports = __webpack_public_path__ + "img/topoAzul.b8359c18.png";